import React from "react";

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api"
import Types from "constants/Types";
import APPCONFIG from "constants/Config";
import {Button} from "reactstrap";
import {Collections} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import ObjectOverride from "components/ObjectOverride";
import FFLTextField from "components/Elements/FFLTextField";


/**
 *  @property {Importers_Object} state
 *  @property {object} model
 *  @property {Importers_Properties} model.properties
 *  @property {Importers_Is} model.is
 *  @property {Importers_Has} model.has
 */
export default class ImporterObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Importers._name);

		this.state.modalFFLLookup = false;
		this.handleFFLExpiration= this.handleFFLExpiration.bind(this)
	}

	/**
	 * @param prevProps
	 * @param {Importers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Importers_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_display ? object.name_display : object.name_company);
		}
	}


	handleFFLExpiration =(e)=>{
		this.state.ffl_expiration=e.date
	}

	form = () => {
		/** @type {Importers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Importers_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							{/*#region Importer Information*/}
							<h4 className="section-title">Importer Information</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer Name"}
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Country Of Origin"}
									property={properties.country_of_origin}
									value={object.country_of_origin}
									error={object.country_of_origin_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}
							{/*#region Address*/}
							<h4 className="section-title">Address</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Full Address"}
									property={properties.full_address}
									value={object.full_address}
									error={object.full_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							{/*#endregion*/}
						</div>

						<div className={"col-md"}>
							{/*#region Contact Information*/}
							<h4 className="section-title">Contact Information</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Phone Number"}
											property={properties.phone_number}
											value={object.phone_number}
											error={object.phone_number_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}
							{/*#region Federal Firearms License*/}
							<h4 className="section-title" style={{position: 'relative'}}>
								Federal Firearms License
							</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer FFL"}
									property={properties.ffl}
									value={object.ffl}
									error={object.ffl_error}
									update={this.handleTextFieldPropertyUpdate}
									disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.Date
									label={"FFL Expiration"}
									property={properties.ffl_expiration}
									value={object.ffl_expiration}
									error={object.ffl_expiration_error}
									update={this.handleTextFieldPropertyUpdate}
									disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
								/>
							</div>


						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
